import { createFileRoute, redirect, useParams } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";
import { SubscriptionPage } from "../pages/SubscriptionPage";
import { storage } from "../lib/storage";

const langMap: Record<string, string> = {
  oz: "uz-Latn",
  uz: "uz-Cyrl",
  ru: "ru",
  en: "en-US",
};

export const Route = createFileRoute("/$lang/subscription")({
  beforeLoad: () => {
    if (typeof window !== "undefined" && !storage.getItem("auth_token")) {
      throw redirect({ to: "/" });
    }
  },
  component: Subscription,
});

function Subscription() {
  const { lang } = useParams({ from: "/$lang/subscription" });
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = langMap[lang] || "uz-Latn";
    if (i18n?.changeLanguage) i18n.changeLanguage(lang);
  }, [lang, i18n]);
  return (
    <LangProvider lang={langMap[lang] || "uz-Latn"}>
      <SubscriptionPage />
    </LangProvider>
  );
}
